import { NgModule } from '@angular/core';
import * as Highcharts from 'highcharts';
import more from 'highcharts/highcharts-more';
import solidguage from 'highcharts/modules/solid-gauge';
import treemap from 'highcharts/modules/treemap';
import drilldown from 'highcharts/modules/drilldown';
import accessibility from 'highcharts/modules/accessibility';
import { ChartComponent } from './chart.component';

import HighchartsGroupedCategories from './group-cat';

@NgModule({
    declarations: [ChartComponent],
    exports: [ChartComponent],
})
export class ChartModule {
    constructor() {
        more(Highcharts);
        solidguage(Highcharts);
        HighchartsGroupedCategories(Highcharts);
        treemap(Highcharts);
        drilldown(Highcharts);
        accessibility(Highcharts);
    }
}
